import Vue from 'vue'
import Router from 'vue-router'
import Buy from './views/Buy.vue'
import Trial from './views/Trial.vue'
import Upgrade from './views/Upgrade.vue'

Vue.use(Router)

export default new Router({
  base: window.JSparams.request_uri,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash !== '') {
        return {
          selector: to.hash,
          offset: { x: 0, y: 92 }
        }
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/signup/:email?',
      name: 'Trial',
      component: Trial
    },
    {
      path: '/upgrade/:email/:instanceId',
      name: 'Upgrade',
      component: Upgrade
    },
    {
      path: '/:package?/:cloudoffice?/:step?',
      name: 'Buy',
      component: Buy,
      beforeEnter: (to, from, next) => {
        if (typeof (to.params.package) === 'undefined' || (to.params.package !== 'basic' && to.params.package !== 'advanced' && to.params.package !== 'educational')) {
          next({ name: 'Buy', params: { package: 'advanced' } })
        } else {
          next()
        }
      }
    }
  ]
})
